import { ColDef } from '@ag-grid-community/core';

export const defaultColDef = {
  editable: false,
  resizable: true,
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    buttons: ['apply', 'reset'],
  },
};

export const columnDefs: ColDef[] = [
  { headerName: 'Order', field: 'orderid_shipid', lockVisible: true, lockPosition: true, cellStyle: { 'text-align': 'center' } },
  { headerName: 'Item', field: 'item', lockVisible: true, lockPosition: true, cellStyle: { 'text-align': 'center' } },
  { headerName: 'Alias', field: 'alias', cellStyle: { 'text-align': 'center' } },
  { headerName: 'Lot Number', field: 'lotnumber', editable: true, cellStyle: { 'text-align': 'center' } },
  { headerName: 'Line Status', field: 'linestatus', cellStyle: { 'text-align': 'center' } },
  {
    headerName: 'Ordered UOM',
    field: 'uom',
    cellStyle: { 'text-align': 'center' },
  },
  {
    headerName: 'Entered UOM',
    field: 'uomentered',
    editable: true,
    cellStyle: { 'text-align': 'center' },
  },
  { headerName: 'Qty Entered', field: 'qtyentered', editable: true, cellStyle: { 'text-align': 'right' } },
  { headerName: 'Qty Order', field: 'qtyorder', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Qty Commit', field: 'qtycommit', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Qty Picked', field: 'qtypick', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Qty Shipped', field: 'qtyship', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight UOM', field: 'weightuom', cellStyle: { 'text-align': 'center' } },
  { headerName: 'Weight Entered', field: 'weightentered', editable: true, cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight Order', field: 'weightorder', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight Commit', field: 'weightcommit', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight Picked', field: 'weightpick', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight Shipped', field: 'weightship', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Weight Received', field: 'weightrcvd', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Variance Shipped', field: 'ship_variance', cellStyle: { 'text-align': 'center' } },
  { headerName: 'Qty Received', field: 'qtyrcvd', cellStyle: { 'text-align': 'right' } },
  { headerName: 'Variance Received', field: 'rcvd_variance', cellStyle: { 'text-align': 'center' } },
  { headerName: 'Hazardous', field: 'hazardous', cellStyle: { 'text-align': 'center' } },
];

export const defColumnPreferences = [
  {
    colId: 'orderid_shipid',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'item', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'alias', hide: true, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'lotnumber', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'linestatus', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'uom', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'uomentered', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightuom', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyentered', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyorder', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtycommit', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtypick', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyship', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightentered', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightorder', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightcommit', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightpick', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightship', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'weightrcvd', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'ship_variance',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'qtyrcvd', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'rcvd_variance',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'hazardous', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },

  { colId: 'allowsub', hide: true },
  { colId: 'amt2check', hide: true },
  { colId: 'amt2pack', hide: true },
  { colId: 'amt2sort', hide: true },
  { colId: 'amtcommit', hide: true },
  { colId: 'amtorder', hide: true },
  { colId: 'amtpick', hide: true },
  { colId: 'amtrcvd', hide: true },
  { colId: 'amtrcvddmgd', hide: true },
  { colId: 'amtrcvdgood', hide: true },
  { colId: 'amtship', hide: true },
  { colId: 'amttotcommit', hide: true },
  { colId: 'asnvariance', hide: true },
  { colId: 'backorder', hide: true },
  { colId: 'cancelreason', hide: true },
  { colId: 'childorderid', hide: true },
  { colId: 'childshipid', hide: true },
  { colId: 'comment1', hide: true },
  { colId: 'commitstatus', hide: true },
  { colId: 'consigneesku', hide: true },
  { colId: 'consigneesku_1', hide: true },
  { colId: 'cube2check', hide: true },
  { colId: 'cube2pack', hide: true },
  { colId: 'cube2sort', hide: true },
  { colId: 'cubecommit', hide: true },
  { colId: 'cubeorder', hide: true },
  { colId: 'cubepick', hide: true },
  { colId: 'cubercvd', hide: true },
  { colId: 'cubercvddmgd', hide: true },
  { colId: 'cubercvdgood', hide: true },
  { colId: 'cubeship', hide: true },
  { colId: 'cubetotcommit', hide: true },
  { colId: 'custid', hide: true },
  { colId: 'custid_1', hide: true },
  { colId: 'dtlpassthruchar01', hide: true },
  { colId: 'dtlpassthruchar02', hide: true },
  { colId: 'dtlpassthruchar03', hide: true },
  { colId: 'dtlpassthruchar04', hide: true },
  { colId: 'dtlpassthruchar05', hide: true },
  { colId: 'dtlpassthruchar06', hide: true },
  { colId: 'dtlpassthruchar07', hide: true },
  { colId: 'dtlpassthruchar08', hide: true },
  { colId: 'dtlpassthruchar09', hide: true },
  { colId: 'dtlpassthruchar10', hide: true },
  { colId: 'dtlpassthruchar11', hide: true },
  { colId: 'dtlpassthruchar12', hide: true },
  { colId: 'dtlpassthruchar13', hide: true },
  { colId: 'dtlpassthruchar14', hide: true },
  { colId: 'dtlpassthruchar15', hide: true },
  { colId: 'dtlpassthruchar16', hide: true },
  { colId: 'dtlpassthruchar17', hide: true },
  { colId: 'dtlpassthruchar18', hide: true },
  { colId: 'dtlpassthruchar19', hide: true },
  { colId: 'dtlpassthruchar20', hide: true },
  { colId: 'dtlpassthruchar21', hide: true },
  { colId: 'dtlpassthruchar22', hide: true },
  { colId: 'dtlpassthruchar23', hide: true },
  { colId: 'dtlpassthruchar24', hide: true },
  { colId: 'dtlpassthruchar25', hide: true },
  { colId: 'dtlpassthruchar26', hide: true },
  { colId: 'dtlpassthruchar27', hide: true },
  { colId: 'dtlpassthruchar28', hide: true },
  { colId: 'dtlpassthruchar29', hide: true },
  { colId: 'dtlpassthruchar30', hide: true },
  { colId: 'dtlpassthruchar31', hide: true },
  { colId: 'dtlpassthruchar32', hide: true },
  { colId: 'dtlpassthruchar33', hide: true },
  { colId: 'dtlpassthruchar34', hide: true },
  { colId: 'dtlpassthruchar35', hide: true },
  { colId: 'dtlpassthruchar36', hide: true },
  { colId: 'dtlpassthruchar37', hide: true },
  { colId: 'dtlpassthruchar38', hide: true },
  { colId: 'dtlpassthruchar39', hide: true },
  { colId: 'dtlpassthruchar40', hide: true },
  { colId: 'dtlpassthrudate01', hide: true },
  { colId: 'dtlpassthrudate02', hide: true },
  { colId: 'dtlpassthrudate03', hide: true },
  { colId: 'dtlpassthrudate04', hide: true },
  { colId: 'dtlpassthrudoll01', hide: true },
  { colId: 'dtlpassthrudoll02', hide: true },
  { colId: 'dtlpassthrunum01', hide: true },
  { colId: 'dtlpassthrunum02', hide: true },
  { colId: 'dtlpassthrunum03', hide: true },
  { colId: 'dtlpassthrunum04', hide: true },
  { colId: 'dtlpassthrunum05', hide: true },
  { colId: 'dtlpassthrunum06', hide: true },
  { colId: 'dtlpassthrunum07', hide: true },
  { colId: 'dtlpassthrunum08', hide: true },
  { colId: 'dtlpassthrunum09', hide: true },
  { colId: 'dtlpassthrunum10', hide: true },
  { colId: 'dtlpassthrunum11', hide: true },
  { colId: 'dtlpassthrunum12', hide: true },
  { colId: 'dtlpassthrunum13', hide: true },
  { colId: 'dtlpassthrunum14', hide: true },
  { colId: 'dtlpassthrunum15', hide: true },
  { colId: 'dtlpassthrunum16', hide: true },
  { colId: 'dtlpassthrunum17', hide: true },
  { colId: 'dtlpassthrunum18', hide: true },
  { colId: 'dtlpassthrunum19', hide: true },
  { colId: 'dtlpassthrunum20', hide: true },
  { colId: 'excludefromvas', hide: true },
  { colId: 'fromfacility', hide: true },
  { colId: 'invclassind', hide: true },
  { colId: 'inventoryclass', hide: true },
  { colId: 'invstatus', hide: true },
  { colId: 'invstatusind', hide: true },
  { colId: 'item_1', hide: true },
  { colId: 'itemdescr', hide: true },
  { colId: 'itementered', hide: true },
  { colId: 'lastupdate', hide: true },
  { colId: 'lastuser', hide: true },
  { colId: 'lineorder', hide: true },
  { colId: 'linestatus_1', hide: true },
  { colId: 'linestatusabbrev', hide: true },
  { colId: 'lotnumber_1', hide: true },
  { colId: 'min_days_to_expiration', hide: true },
  { colId: 'orderid', hide: true },
  { colId: 'orderid_1', hide: true },
  { colId: 'orderstatus', hide: true },
  { colId: 'orderstatusabbrev', hide: true },
  { colId: 'ordertype', hide: true },
  { colId: 'priority', hide: true },
  { colId: 'qty2check', hide: true },
  { colId: 'qty2pack', hide: true },
  { colId: 'qty2sort', hide: true },
  { colId: 'qtycommit_1', hide: true },
  { colId: 'qtyentered_1', hide: true },
  { colId: 'qtyorder_1', hide: true },
  { colId: 'qtyorderdiff', hide: true },
  { colId: 'qtyoverpick', hide: true },
  { colId: 'qtypick_1', hide: true },
  { colId: 'qtyrcvd_1', hide: true },
  { colId: 'qtyrcvddmgd', hide: true },
  { colId: 'qtyrcvdgood', hide: true },
  { colId: 'qtyreturnedtostock', hide: true },
  { colId: 'qtyscrapped', hide: true },
  { colId: 'qtyship_1', hide: true },
  { colId: 'qtytotcommit', hide: true },
  { colId: 'qtytype', hide: true },
  { colId: 'rcvdvariance', hide: true },
  { colId: 'receipt_weight_confirmed', hide: true },
  { colId: 'rfautodisplay', hide: true },
  { colId: 'shipid', hide: true },
  { colId: 'shipid_1', hide: true },
  { colId: 'shipshortreason', hide: true },
  { colId: 'shipvariance', hide: true },
  { colId: 'staffhrs', hide: true },
  { colId: 'statusupdate', hide: true },
  { colId: 'statususer', hide: true },
  { colId: 'unrestrict_lot_sub', hide: true },
  { colId: 'uom', hide: true },
  { colId: 'uom_1', hide: true },
  { colId: 'uomabbrev', hide: true },
  { colId: 'uomentered_1', hide: true },
  { colId: 'variancepct', hide: true },
  { colId: 'variancepct_overage', hide: true },
  { colId: 'variancepct_use_default', hide: true },
  { colId: 'vasconsumable', hide: true },
  { colId: 'vasid', hide: true },
  { colId: 'weight2check', hide: true },
  { colId: 'weight2pack', hide: true },
  { colId: 'weight2sort', hide: true },
  { colId: 'weight_entered_kgs', hide: true },
  { colId: 'weight_entered_lbs', hide: true },
  { colId: 'weightcommit_1', hide: true },
  { colId: 'weightorder_1', hide: true },
  { colId: 'weightpick_1', hide: true },
  { colId: 'weightrcvd_1', hide: true },
  { colId: 'weightrcvddmgd', hide: true },
  { colId: 'weightrcvdgood', hide: true },
  { colId: 'weightship_1', hide: true },
  { colId: 'weighttotcommit', hide: true },
  { colId: 'xdocklocid', hide: true },
  { colId: 'xdockorderid', hide: true },
  { colId: 'xdockshipid', hide: true },
];

export function calculateFields(rowdata: any[]) {
  const newRowdata: any[] = [];
  if (!rowdata?.length) {
    return newRowdata;
  }
  rowdata = JSON.parse(JSON.stringify(rowdata));
  for (const row of rowdata) {
    const newRow = JSON.parse(JSON.stringify(row));
    if (row.orderid) {
      newRow.orderid_shipid = `${row.orderid}-${row.shipid}`;
    }
    newRowdata.push(newRow);
  }
  return newRowdata;
}
